<template>
    <div class="FormUse" >
        <el-dialog   :modelValue="dialogFormVisible" :show-close="false"  :before-close="userClose">
            <div slot="title" class="formTitle">
                <div class="formTitle-title">申请体验</div>
                <div class="formTitle-text" @click="FormOut">X</div>
            </div>
                <el-form :model="form" ref="form" :rules="rules">
                   <el-form-item label="公司名称" prop="company_name">
                     <el-input v-model="form.company_name" autocomplete="off" placeholder="请输入完整的公司名称"></el-input>
                   </el-form-item>
                   <el-form-item label="姓名" prop="user_name">
                     <el-input v-model="form.user_name" autocomplete="off" placeholder="请输入您的姓名"></el-input>
                   </el-form-item>
                   <el-form-item label="职位" prop="job">
                     <el-input v-model="form.job" autocomplete="off" placeholder="请输入您的职位"></el-input>
                   </el-form-item>
                   <el-form-item label="联系电话" prop="phone" >
                     <el-input v-model.number="form.phone" autocomplete="off" placeholder="请输入您的联系电话"></el-input>
                   </el-form-item>
                   <el-form-item label="联系邮箱" >
                     <el-input v-model="form.email" autocomplete="off" placeholder="请输入您的联系邮箱"></el-input>
                   </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <!-- <el-button type="primary" >提交</el-button> -->
                  <div class="footerText" @click="FormSubmit('form')">
                    提交
                  </div>
                </div>
        </el-dialog>
    </div>
</template>
  
<script>
import { useEnterprise } from "@/server/index.js";

export default {
    name: 'HomeForm',
    props: {
        dialogFormVisible: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            form: {
                company_name: '',
                user_name: '',
                job: '',
                phone: '',
                email: '',
                // type: [],
                // resource: '',
                // desc: ''
        }, 
        rules: {
            company_name: [
            { required: true, message: '公司名称不能为空'}
          ],
          user_name: [
            { required: true, message: '姓名不能为空' }
          ],
          job: [
            { required: true, message: '职位不能为空' }
          ],
          phone: [
            { required: true, message: '联系电话不能为空'},
            { type: 'number', message: '电话必须为数字值'},
            { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式不正确', trigger: 'blur' }
            ]       
      },
        // dialogFormVisible: true,
        }
    },
    methods:{
        FormOut() {
            this.$emit('FormOut')
        },
        FormSubmit(formName) {
            this.$refs[formName].validate((valid) => {
                 if (valid) {
                    console.log(this.form)
                    let params = {
                        company_name: this.form.company_name,
                        user_name: this.form.user_name,
                        job: this.form.job,
                        phone: this.form.phone,
                        email: this.form.email,
                    }
                    useEnterprise(params).then(res =>{
                        this.$notify({
                            title: '成功',
                            message: '企业申请成功',
                            type: 'success'
                         });
                         this.$refs[formName].resetFields()
                         this.form.email = ''
                        //  this.form = {}
                    })
                   this.$emit('FormSubmit')
                 } else {
                   console.log('error submit!!');
                   return false;
                 }
        });
        },
        userClose() {
          this.$emit("userClose", false)
        }

    },
    created() {
        console.log(this.dialogFormVisible)
    }
}
</script>
<style lang="less" scoped>
    .FormUse {
        /deep/ .el-dialog__header {
            padding: 0;
            padding-bottom: 0;
            margin-right: 0;
        }
      :deep(.el-dialog) {
            width: 520rem;
            height: 620rem;
            .el-dialog__body {
                height: 100%;
                padding: 34rem;
                .el-form-item {
                    display: flex;
                    --font-size: 14rem;
                    margin-bottom: 24rem;
                    flex-direction: column;
                    .el-input__inner::placeholder{
                        font-size: 14rem;
                        font-family: PingFang-SC-Regular, PingFang-SC;
                        font-weight: 400;
                        color: #999999;
                        padding: 2rem;
                    }
                    .el-form-item__label {
                      display: inline-flex;
                      flex: 0 0 auto;
                      height: 32rem;
                      line-height: 32rem;
                      padding: 0 12rem 0 0;
                      box-sizing: border-box;
                      font-size: 16rem;
                      font-family: PingFangSC-Medium, PingFang SC;
                      font-weight: 1000;
                      color: #333333;
                      flex-direction: row-reverse;
                  
                    }
                    .el-form-item__content {
                      display: flex;
                      width: 452rem;
                      height: 42rem;
                      flex-wrap: wrap;
                      align-items: center;
                      flex: 1;
                      line-height: 32px;
                      position: relative;
                      font-size: var(--font-size);
                      min-width: 0;
                      .el-input {
                         position: relative;
                         font-size: var(--el-font-size-base);
                         display: inline-flex;
                         height: 42rem;
                         width: var(--el-input-width);
                         box-sizing: border-box;
                         vertical-align: middle;
                         .el-input__inner {
                            height: 42rem;
                         }
                        }
                      .el-form-item__error {
                        color: var(--el-color-danger);
                        font-size: 12rem;
                        line-height: 1;
                        padding-top: 2rem;
                        position: absolute;
                        top: 100%;
                        left: 0;
                      }
                    }
                }
                .formTitle {
                    width: 100%;
                    height: 40rem;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 13rem;
                    margin-top: -25rem;
                    border-bottom: 1rem solid rgba(151, 151, 151, 0.2);
                    &-text {
                        cursor: pointer;
                        width: 14rem;
                        height: 14rem;
                        font-size: 14rem;
                    }
                    &-title {
                      width: 98%;
                      font-size: 18rem;
                      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                      font-weight: bolder;
                      color: #333333;
                    }
                }
                .dialog-footer {
                    width: 100%;
                    height: 59rem;
                    display: flex; 
                    justify-content: center;
                    align-items: center;
                    border-top: 1rem solid rgba(151, 151, 151, 0.2);
                    .footerText {
                        width: 154rem;
                        height: 32rem;
                        background: #505BFF;
                        border-radius: 4rem;
                        font-size: 14rem;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #FFFFFF;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;
                }
                }
               
        }
        .el-form-item.is-required:not(.is-no-asterisk).asterisk-left>.el-form-item__label-wrap>.el-form-item__label:before, .el-form-item.is-required:not(.is-no-asterisk).asterisk-left>.el-form-item__label:before {
                  content: "*";
                  color: var(--el-color-danger);
                  margin-left: 5rem;
                  margin-top: 3rem;
            }
                      
        }
       
    }
    // /deep/ .el-popup-parent--hidden {
    //   width: 100%;
    // }
//     :deep(.el-popup-parent--hidden) {
//   padding-right: 0px ;
//   overflow: hidden ;
//   width: 100%;
// }
</style>
  